import React, { useState, useEffect } from 'react';
import { Table, Button, Drawer, KeyValuePairs, FlashbarProps, Flashbar, HelpPanel, SplitPanel, Link, FormField, Alert } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import Pagination from '@cloudscape-design/components/pagination';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Box from '@cloudscape-design/components/box';
import CollectionPreferences from '@cloudscape-design/components/collection-preferences';
import ButtonDropdown from '@cloudscape-design/components/button-dropdown';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { formatPhone, storeJWT } from '../../../commons/functions';
import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { mdiBoomGateOutline, mdiEmail, mdiHelpCircleOutline, mdiHomeVariantOutline, mdiInformationSlabBoxOutline, mdiPhone } from '@mdi/js';
import Icon from '@mdi/react';
import { boolean } from 'zod';

const pageSize = 20;

export const UsersAuthorizePage = () => {
  const storeAdmin = useStoreAdmin();
  const { idPropiedad, setIdPropiedad } = useGlobalState();
  const { propiedad, setPropiedad } = useGlobalState();
  const { idControl, setIdControl } = useGlobalState();
  const { JWT, setJWT } = useGlobalState();


  const [selectedRow, setSelectedRow] = useState<any>(null);  // Stores selected row data
  const [helpOpen, setHelpOpen] = useState(false);
  const [sideOpen, setSideOpen] = useState(false);
  const [btnAuths, setBtnAuths] = useState(true);

  const [selectedAccesses, setSelectedAccesses] = useState<string[]>([]);

  const {
    actions: { makeHelpPanelHandler },
  } = useStore();
  const { navigate } = useRouter();
  const [selectedItems, setSelectedItems] = useState<UserItem[]>([]);
  const { setLoading } = useGlobalState();
  const [btnActionDisable, setBtnActionDisable] = useState<boolean>(true);
  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  const [filteringText, setFilteringText] = useState('');
  const [users, setUsers] = useState<UserItem[]>([]);
  const [messages, setMessages] = useState<FlashbarProps.MessageDefinition[]>([]);

  type Access = {
    idAcceso: string;
    acceso: string;
    idAutorizado: string;
    hashAutorizado: string;
    label: string;
    id: string;
  };

  type UserItem = {
    displayName: string;
    movil: string;
    unidad: string;
    idUnidad: number;
    accesos: string;
    idControl: string;
    email: string;
    reqInfoUnidad: number;
    reqInfoTitle: string;
    reqInfo: string;
    accesses: string[];
  };

  const handleCheckboxChange = (accessId: string) => {
    setSelectedAccesses((prev) => {
      // If the access is already selected, remove it from the array, else add it
      if (prev.includes(accessId)) {
        return prev.filter(id => id !== accessId);
      } else {
        return [...prev, accessId];
      }
    });
  };
  const filteredUsers = users.filter(user => {
    const searchWords = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
    return searchWords.every(word =>
      user.displayName.toLowerCase().includes(word) ||
      user.movil.toLowerCase().includes(word) ||
      user.unidad.toLowerCase().includes(word)
    );
  });

  const paginatedUsers = filteredUsers.slice(
    (currentPageIndex - 1) * pageSize,
    currentPageIndex * pageSize
  );

  const handleSelectionChange = ({ detail }: any) => {
    setSelectedItems(detail.selectedItems);
    setBtnActionDisable(detail.selectedItems.length === 0);
    if (detail.selectedItems.length > 1) setSideOpen(false);
  };

  useEffect(() => {
    setBtnAuths(selectedAccesses.length == 0)
  }, [selectedAccesses]); // The effect runs every time selectedAccesses changes

  // Handle row click to fetch additional data and open the HelpPanel
  const handleRowClick = async (rowData: UserItem) => {
    setMessages([])
    setSelectedRow(rowData);  // Store selected row data
    setLoading(true);
    try {
      // Simulate a fetch request to get additional data for the row
      // Example of a fetched data structure
      const userDetails = {
        displayName: rowData.displayName,
        unidad: rowData.unidad,
        idUnidad: rowData.idUnidad,
        accesos: rowData.accesos,
        accesses: rowData.accesses,
        email: rowData.email,
        movil: rowData.movil,
      };
      //setSelectedRow(userDetails);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
      setHelpOpen(false);
      setSideOpen(true);

      setSelectedAccesses([]);
    }
  };
  useEffect(() => {
  }, [selectedRow]);
  const handleRefresh = async () => {

    setHelpOpen(false);
    setSideOpen(false);
    try {
      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/users/pending.auth',
          'JWT': JWT,

        },
        body: JSON.stringify({

        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();

      storeAdmin(data);
      /*
      if(data.admin && data.admin.menu) {
        console.log("CHANGE MENU")
        setMenu(data.admin.menu)
      }
        */
      // Create a new list with updated 'accesos' field before setting it to state
      const updatedUsers = data.authorizations.map((user: UserItem) => ({
        ...user,
        accesos: user.accesses.length.toString(), // setting 'accesos' to the length of 'accesses'
      }));
      console.log(updatedUsers)
      setUsers(updatedUsers);

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);

    }
  };


  useEffect(() => {

    handleRefresh();
  }, []);

  const handleMassiveAuth = async (auth: boolean): Promise<void> => {
    const authorizations: { hashAutorizado: any; auth: boolean; idUnidad: any; }[] = [];
    selectedItems.forEach((item: any) => {
      item.accesses.forEach((access: any) => {
        authorizations.push({
          hashAutorizado: access.hashAutorizado,
          auth: auth,
          idUnidad: item.idUnidad,
        })
      });
    });

    const body = {
      authorizations: authorizations
    }
    try {
      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/users/auth',
          'JWT': JWT,

        },
        body: JSON.stringify(body)
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();

      storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state
      if (data.code === 0) {
        setMessages([
          {
            type: 'success',
            content: `${data.status}`,
            id: 'status200',
            dismissible: true,
            onDismiss: () => setMessages([]),
          },
        ]);
        handleRefresh();
      } else {

        setMessages([
          {
            type: 'error',
            content: `${data.status}`,
            id: 'status200',
            dismissible: true,
            onDismiss: () => setMessages([])
          },
        ]);
      }

    } catch (error) {
      console.error('Error fetching users:', error);
      setMessages([
        {
          type: 'error',
          content: `${error}`,
          id: 'server-error',
          dismissible: true,
          onDismiss: () => setMessages([]),
        },
      ]);
    } finally {
      setLoading(false);
      //setPendingLoading(false);

    }
  }
  const handleAuth = async (auth: boolean): Promise<void> => {

    const authorizations = []
    for (const item of selectedAccesses) {
      const authorization = {
        hashAutorizado: item,
        authorized: auth,
        idUnidad: selectedRow.idUnidad
      }
      authorizations.push(authorization)
    }

    const body = {
      units: true,
      authorizations: authorizations
    }
    console.log(body)

    try {
      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/users/auth',
          'JWT': JWT,

        },
        body: JSON.stringify(body)
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();

      storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state
      if (data.code === 0) {
        setMessages([
          {
            type: 'success',
            content: `${data.status}`,
            id: 'status200',
            dismissible: true,
            onDismiss: () => setMessages([]),
          },
        ]);
        handleRefresh();
      } else {

        setMessages([
          {
            type: 'error',
            content: `${data.status}`,
            id: 'status200',
            dismissible: true,
            onDismiss: () => setMessages([])
          },
        ]);
      }

    } catch (error) {
      console.error('Error fetching users:', error);
      setMessages([
        {
          type: 'error',
          content: `${error}`,
          id: 'server-error',
          dismissible: true,
          onDismiss: () => setMessages([]),
        },
      ]);
    } finally {
      setLoading(false);
      //setPendingLoading(false);

    }
  };

  //selectedRow.reqInfoUnidad === 1 && 
  return (
    <CustomAppLayout
      toolsOpen={helpOpen}
      onToolsChange={({ detail }) => setHelpOpen(detail.open)}
      splitPanelOpen={sideOpen}
      onSplitPanelToggle={({ detail }) => setSideOpen(detail.open)}
      splitPanel={


        selectedRow && (
          <SplitPanel hidePreferencesButton header={selectedRow.displayName} closeBehavior='hide'>
            <div>
              {selectedRow ? (
                <>
                  <SpaceBetween size='xs' direction="vertical">
                    <KeyValuePairs
                      columns={2}
                      items={[
                        {
                          label: <span><Icon path={mdiPhone} size={0.7} /> Móvil</span>,
                          value: formatPhone(selectedRow.movil),
                        },
                        {
                          label: <span><Icon path={mdiBoomGateOutline} size={0.7} /> Accesos</span>,
                          value: selectedRow.accesos,
                        },
                        {
                          label: <span><Icon path={mdiEmail} size={0.7} /> Email</span>,
                          value: selectedRow.email,
                        },
                        {
                          label: <span><Icon path={mdiHomeVariantOutline} size={0.7} /> Unidad</span>,
                          value: selectedRow.unidad,
                        },
                      ]}
                    />
                    {selectedRow.reqInfoUnidad === 1 && (
                      <Alert header={selectedRow.reqInfoTitle} type="warning">
                        {selectedRow.reqInfo}
                      </Alert>

                    )}

                    <KeyValuePairs
                      columns={1}
                      items={[
                        {
                          label: (
                            <span>
                              <Icon path={mdiInformationSlabBoxOutline} size={0.7} />
                              Accesos
                            </span>
                          ),
                          value: (
                            <SpaceBetween size="xs" direction="vertical">
                              {selectedRow.accesses && selectedRow.accesses.length > 0 ? (
                                selectedRow.accesses.map((acceso: Access) => (
                                  <div key={acceso.idAcceso} style={{ display: 'flex', alignItems: 'center' }}>
                                    <input
                                      type="checkbox"
                                      id={`access-${acceso.idAcceso}`}
                                      value={acceso.hashAutorizado}
                                      checked={selectedAccesses.includes(acceso.hashAutorizado)}
                                      onChange={() => handleCheckboxChange(acceso.hashAutorizado)}
                                    />
                                    <label htmlFor={`access-${acceso.idAcceso}`} style={{ marginLeft: '8px' }}>
                                      {acceso.acceso}
                                    </label>
                                  </div>
                                ))
                              ) : (
                                <div>No hay accesos disponibles.</div>
                              )}
                            </SpaceBetween>
                          ),
                        },
                      ].filter(Boolean)}
                    />

                  </SpaceBetween>
                </>
              ) : (
                <p>No hay datos seleccionados.</p>
              )}
            </div>
            <div style={{ height: '20px' }}></div>
            <SpaceBetween size='xs' alignItems="end" direction="horizontal">
              <Button variant="primary" disabled={btnAuths} onClick={() => handleAuth(true)}>Autorizar</Button>
              <Button variant="normal" disabled={btnAuths} onClick={() => handleAuth(false)}>Denegar</Button>
            </SpaceBetween>

          </SplitPanel>

        )}
      tools={
        helpOpen && (
          <HelpPanel
            header={
              <Header variant="h2">Ayuda</Header>
            }
          ><p>Los usuarios que hayan solicitado uno o más accesos desde la App de LlaveMovil se encuentran en estado pendiente para su autorización.</p>

            <p>Usted puede seleccionar individualmente un usuario para ver los detalles y autorizar o denegar uno o más accesos o bien seleccionar uno o más usuarios y realizar una autorización o denegación masiva.</p>

          </HelpPanel>
        )
      }

      contentType="form"
      breadcrumbs={
        <BreadcrumbGroup
          items={[
            { text: 'Inicio', href: '#home' },
            { text: 'Usuarios', href: '#users' },
            { text: 'Autorizaciones pendientes', href: '#create-transcription-job' },
          ]}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={<>
        <SpaceBetween size='xs'>
          <Flashbar items={messages} />
          <Table
            stripedRows
            renderAriaLive={({ firstIndex, lastIndex, totalItemsCount }) =>
              `Displaying items ${firstIndex} to ${lastIndex} of ${totalItemsCount}`
            }
            onSelectionChange={handleSelectionChange}
            selectedItems={selectedItems}
            onRowClick={({ detail }) => handleRowClick(detail.item)}
            ariaLabels={{
              selectionGroupLabel: "Items selection",
              allItemsSelectionLabel: () => "select all",
              itemSelectionLabel: ({ selectedItems }, item) => item.idControl,
            }}
            columnDefinitions={[
              {
                id: "movil",
                header: "Móvil",
                cell: (item) => formatPhone(item.movil),
                sortingField: "movil",
                isRowHeader: true,
              },
              {
                id: "displayName",
                header: "Usuario",
                cell: (item) => item.displayName,
                sortingField: "displayName",
              },
              {
                id: "unidad",
                header: "Unidad",
                cell: (item) => item.unidad,
              },
              {
                id: "accesos",
                header: "Accesos",
                cell: (item) => item.accesses.length,
              },
            ]}
            items={paginatedUsers}
            selectionType="multi"
            trackBy="idControl"
            empty={
              <Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
                <SpaceBetween size="m">
                  <b>No tiene auytorizaciones pendientes</b>
                </SpaceBetween>
              </Box>
            }
            filter={
              <TextFilter
                filteringText={filteringText}
                onChange={({ detail }) => {
                  setFilteringText(detail.filteringText);
                  setCurrentPageIndex(1);
                }}
              />
            }
            pagination={
              <Pagination
                currentPageIndex={currentPageIndex}
                pagesCount={Math.ceil(filteredUsers.length / pageSize)}
                onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
              />
            }

            header={
              <Header
                counter={
                  selectedItems.length
                    ? "(" + selectedItems.length + "/" + users.length + ")"
                    : ""
                }
                info={<Link onClick={() => setHelpOpen(!helpOpen)}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
                actions={
                  <SpaceBetween direction="horizontal" size="xs">
                    <ButtonDropdown
                      items={[
                        {
                          text: "Autorizar seleccionados",
                          id: "auth",
                          disabled: false
                        },
                        {
                          text: "Denegar seleccionados",
                          id: "deny",
                          disabled: false
                        },
                      ]}
                      onItemClick={({ detail }) => {
                        if (detail.id === "auth") {
                          handleMassiveAuth(true)
                        } else if (detail.id === "deny") {
                          // handle denial
                          handleMassiveAuth(false)
                        }
                      }}
                      disabled={btnActionDisable}
                    >
                      Acciones
                    </ButtonDropdown>
                    <Button variant="primary" href='#users/add'>
                      Agregar Usuario
                    </Button>
                    <Button variant="primary" onClick={handleRefresh} iconName="refresh"></Button>
                  </SpaceBetween>
                }
              >Autorizaciones pendientes
              </Header>
            }
          />
        </SpaceBetween>
      </>
      }
    />
  );
};
